import { BENCHMARK_PORTFOLIO, CLIENT_PORTFOLIO, HOUSEHOLD_PORTFOLIO, MODEL_PORTFOLIO, } from 'ModelPortfolioApp/ts/shared/constants';
export const ADDEPAR = 'addepar';
export const ADVYZON = 'advyzon';
export const AVISO = 'aviso';
export const BLACK_DIAMOND = 'black_diamond';
export const EMONEY = 'emoney';
export const FIDELITY = 'fidelity';
export const HARTFORD = 'hartford';
export const ORION = 'orion';
export const REDTAIL = 'redtail';
export const SCHWAB = 'schwab';
export const SCHWAB_RPM_BETA_GROUP = 'schwab_rpm_beta_testers';
export const PERSHING = 'pershing';
export const VRGL = 'vrgl';
export const BROADRIDGE = 'broadridge';
export const RAYMOND_JAMES = 'raymond_james';
export const NORTHWESTERN_MUTUAL = 'northwestern_mutual';
export const LPL = 'lpl';
// Search Modal Types
export const ADDEPAR_GROUP = 'group';
export const ADDEPAR_PORTFOLIO = 'portfolio';
export const ADDEPAR_CLIENT = 'client';
export const ADDEPAR_FUND = 'fund';
export const ADDEPAR_LEGAL_ENTITY = 'legal_entity';
export const ADDEPAR_ACCOUNT = 'account';
export const ADDEPAR_HOUSEHOLD = 'household';
export const ADDEPAR_INVESTMENT = 'investment';
export const ADDEPAR_OAUTH_SCOPES = ['portfolio', 'groups', 'entities', 'positions', 'transactions'];
export const BD_SEARCH_ACCOUNT = 'account';
export const BD_SEARCH_PORTFOLIO = 'portfolio';
export const BROADRIDGE_GROUP = 'group';
export const BROADRIDGE_ACCOUNT = 'account';
export const EMONEY_CLIENT = 'client';
export const EMONEY_PLAN = 'plan';
export const EMONEY_ASSET = 'asset';
export const EMONEY_HOLDING = 'holding';
export const HARTFORD_CLIENT = 'client';
export const HARTFORD_MATRIX = 'matrix';
export const IREBAL_MODEL = 'irebalModel';
export const IREBAL_BLENDED_MODEL = 'irebalBlendedModel';
export const IREBAL_PORTFOLIO = 'irebalPortfolio';
export const NORTHWESTERN_ACCOUNT = 'account';
export const NORTHWESTERN_CLIENT = 'client';
export const ORION_CLIENT = 'client';
export const ORION_ACCOUNT = 'account';
export const ORION_MODEL = 'model';
export const ORION_MODEL_AGGREGATE = 'modelAggregate';
export const ORION_PORTFOLIO_GROUP = 'portfolioGroup';
export const PERSHING_CLIENT = 'client';
export const PERSHING_ACCOUNT = 'account';
export const REDTAIL_CONTACT = 'contact';
export const REDTAIL_ACCOUNT = 'account';
export const SCHWAB_CLIENT = 'client';
export const SCHWAB_ACCOUNT = 'account';
export const VRGL_HOUSEHOLD = 'household';
export const VRGL_ACCOUNT = 'account';
export const VRGL_BENCHMARK = 'benchmark';
export const VRGL_INVESTMENT_STRATEGY = 'investmentStrategy';
export const VRGL_PROPOSAL_ACCOUNT = 'proposalAccount';
// Fidelity Client Headers too generic to identify a firm. Keep in sync with apps/integrations/constants.py.
export const GENERIC_FIDELITY_HEADERS = [
    'fidelity',
    'fidelity investments',
    'fidelity investment',
    'fidelity account',
    'fidelity accounts',
    'my fidelity account',
    'my advisor account',
    'advisor account',
    'my account',
    'wealthscape',
    'ycharts',
];
// Punctuation counts as a word boundary so "Fidelity-Investments" can't slip past the blocklist.
export const isGenericFidelityHeader = (header) => GENERIC_FIDELITY_HEADERS.includes(header
    .replace(/[^\w\s]/g, ' ')
    .trim()
    .replace(/\s+/g, ' ')
    .toLowerCase());
const FIDELITY_BRAND_TOKENS = new Set(['fidelity', 'wealthscape', 'ycharts']);
const FIDELITY_FILLER_TOKENS = new Set([
    'a',
    'an',
    'the',
    'my',
    'of',
    'and',
    'for',
    'account',
    'accounts',
    'advisor',
    'advisors',
    'investment',
    'investments',
    'integration',
    'integrations',
    'data',
    'feed',
    'inc',
    'llc',
    'co',
    'corp',
    'company',
]);
// A header that leans on a brand word ("Fidelity Boston", "AK Fidelity") probably isn't the firm's own name.
// Flags headers containing a brand token with fewer than two distinctive tokens alongside it — distinctive
// meaning not filler, not pure digits, and longer than two characters (state/initial qualifiers are weak).
export const isSuspectFidelityHeader = (header) => {
    const tokens = header
        .toLowerCase()
        .replace(/[^a-z0-9]/g, ' ')
        .split(/\s+/)
        .filter(Boolean);
    if (!tokens.some((token) => FIDELITY_BRAND_TOKENS.has(token))) {
        return false;
    }
    const distinctiveTokens = tokens.filter((token) => !FIDELITY_BRAND_TOKENS.has(token) &&
        !FIDELITY_FILLER_TOKENS.has(token) &&
        token.length > 2 &&
        !/^\d+$/.test(token));
    return distinctiveTokens.length < 2;
};
// Import Error Codes
export const MISSING_IDS = 'integration_missing_ids';
export const AUTH_FAILED = 'integration_authentication_failed';
export const NO_HOLDINGS = 'integration_no_holdings';
export const NO_SEARCH_RESULTS = 'integration_no_search_results';
export const ZERO_ACCOUNT_VALUE = 'integration_zero_account_value';
export const INVALID_ALLOCATION = 'integration_invalid_allocation';
export const INVALID_RESPONSE = 'integration_invalid_response';
export const INVALID_CUSTOM_SECURITY = 'custom_security_error';
export const INVALID_CUSTOM_SECURITY_LEVELS = 'custom_security_levels_error';
export const NO_ASSETS_IN_ACCOUNT = 'no_assets_in_account';
export const REFRESH_INVALID_API_LEVELS = 'refresh_invalid_api_levels';
export const REFRESH_INVALID_ENTITY_ID = 'invalid_entity_id';
export const REFRESH_OUTDATED_ADVYZON_HOLDINGS = 'refresh_outdated_advyzon_holdings';
export const TOTAL_VALUE_IS_ZERO = 'total_value_is_zero';
export const ERROR_CODE_MAP = {
    MISSING_IDS: 'Please select an item(s) before importing.',
    AUTH_FAILED: 'Check that the Integration is active.',
    TOO_MANY_RESULTS: 'The are more than 100 records available for the given search criteria. Please refine your search',
    NO_HOLDINGS: 'The selected item(s) do not have any holdings.',
    NO_SEARCH_RESULTS: 'The selected account(s) could not be found. Please verify the account details and try again.',
    ZERO_ACCOUNT_VALUE: 'The selected item(s) have a total acount value of 0',
    INVALID_ALLOCATION: "The selected matrix's allocations don't add up to 100%, so it can't be imported.",
    INVALID_RESPONSE: 'Something went wrong, please try again or contact support.',
    REMOVED_ACCOUNTS: 'These accounts no longer exist.',
    EXPIRED_OTP: 'Your session has timed out.  Please enter a new One Time Password from your Security Token.',
    INVALID_CUSTOM_SECURITY: 'There is an error with one of the Custom Security attributes.',
    INVALID_CUSTOM_SECURITY_LEVELS: 'There is an error with one of the Custom Security levels.',
    NO_ASSETS_IN_ACCOUNT: 'The selected account(s) do not have any assets.',
    REFRESH_INVALID_API_LEVELS: 'There is a problem with the security levels fetched from the integration provider. Please contact support.',
    REFRESH_INVALID_ENTITY_ID: 'The selected security does not have the information required to perform the refresh. Please contact support.',
    REFRESH_OUTDATED_ADVYZON_HOLDINGS: 'Your advyzon account data is outdated. Please refresh your account data before continuing.',
    TOTAL_VALUE_IS_ZERO: 'The assets have a total value of 0.0, cannot aggregate assets by current value.',
};
export const PARTNER_LOGOS = {
    [ADDEPAR]: 'integrations/images/addepar-logo.png',
    [ADVYZON]: 'integrations/images/advyzon-logo.png',
    [AVISO]: 'integrations/images/aviso-logo.png',
    [BLACK_DIAMOND]: 'integrations/images/black-diamond-logo.png',
    [BROADRIDGE]: 'integrations/images/broadridge-logo.png',
    [EMONEY]: 'integrations/images/emoney-logo.png',
    [HARTFORD]: 'integrations/images/hartford-logo.png',
    [LPL]: 'integrations/images/lpl-logo.png',
    [NORTHWESTERN_MUTUAL]: 'integrations/images/northwestern-mutual-logo.png',
    [ORION]: 'integrations/images/orion-logo.png',
    [PERSHING]: 'integrations/images/pershing-logo.png',
    [RAYMOND_JAMES]: 'integrations/images/raymond-james-logo.png',
    [REDTAIL]: 'integrations/images/redtail-logo.png',
    [SCHWAB]: 'integrations/images/schwab-logo.png',
    [VRGL]: 'integrations/images/vrgl-logo.png',
};
// Import Types
export const IMPORT_TYPE_ACCOUNT = 'account';
export const IMPORT_TYPE_HOLDINGS = 'holdings';
// Refresh custom security status
export const REFRESH_CUSTOM_SECURITY_SAME_LEVELS = 'same_levels';
export const REFRESH_CUSTOM_SECURITY_CALCULATING = 'calculating';
// Model Portfolio types
export const PORTFOLIO_TYPE_OPTIONS_CONFIG = {
    list: [
        { value: MODEL_PORTFOLIO, label: 'Model Portfolio' },
        { value: BENCHMARK_PORTFOLIO, label: 'Benchmark Portfolio' },
        { value: CLIENT_PORTFOLIO, label: 'Client Portfolio' },
        { value: HOUSEHOLD_PORTFOLIO, label: 'Household Portfolio' },
    ],
};
